import React, { useState } from 'react';
import './SharePanel.css';

export default function SharePanel({ username }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const url = `${window.location.origin}${window.location.pathname}?user=${username}`;
    navigator.clipboard.writeText(url).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div className="share">
      <button className="share__btn" onClick={handleCopy} title="Copy shareable link">
        {copied ? (
          <>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
              <path fillRule="evenodd" d="M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"/>
            </svg>
            Copied!
          </>
        ) : (
          <>
            <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
              <path fillRule="evenodd" d="M7.776 3.537a.75.75 0 010 1.5H4.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25V9.224a.75.75 0 011.5 0v3.063A1.75 1.75 0 0111.75 14h-7.5A1.75 1.75 0 012.5 12.25v-7.5c0-.966.784-1.75 1.75-1.75h3.526zm3.75-3.25A1.75 1.75 0 0013.25 2h-2.5a.75.75 0 000 1.5h2.5a.25.25 0 01.25.25v2.5a.75.75 0 001.5 0v-2.5A1.75 1.75 0 0013.25.287H10.75zM8.47 7.53a.75.75 0 001.06-1.06L7.06 4l2.47-2.47a.75.75 0 00-1.06-1.06L5.47 3.47a.75.75 0 000 1.06L8.47 7.53z"/>
            </svg>
            Share
          </>
        )}
      </button>

      <a
        className="share__btn share__btn--ghost"
        href={`https://github.com/${username}`}
        target="_blank"
        rel="noreferrer"
      >
        <svg width="13" height="13" viewBox="0 0 16 16" fill="currentColor">
          <path fillRule="evenodd" d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"/>
        </svg>
        GitHub
      </a>
    </div>
  );
}
